/** Monofonik kare dalga beep'leri — Nokia 3310 ses estetiği. */

let audioCtx: AudioContext | null = null;

/** İlk kullanıcı etkileşiminde AudioContext'i açar/uyandırır (tarayıcı politikası). */
export function ensureAudio(): void {
  if (!audioCtx) {
    const Ctor =
      window.AudioContext ??
      (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (Ctor) {
      try {
        audioCtx = new Ctor();
      } catch {
        audioCtx = null;
      }
    }
  }
  if (audioCtx && audioCtx.state === "suspended") void audioCtx.resume();
}

let enabled = true;

export function setSoundEnabled(value: boolean): void {
  enabled = value;
}

function beep(freq: number, durationMs: number, volume = 0.05): void {
  if (!enabled) return;
  ensureAudio();
  if (!audioCtx) return;
  const osc = audioCtx.createOscillator();
  const gain = audioCtx.createGain();
  osc.type = "square";
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(volume, audioCtx.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.0001, audioCtx.currentTime + durationMs / 1000);
  osc.connect(gain);
  gain.connect(audioCtx.destination);
  osc.start();
  osc.stop(audioCtx.currentTime + durationMs / 1000);
}

function sequence(notes: Array<[freq: number, atMs: number, durationMs?: number]>): void {
  for (const [freq, atMs, durationMs = 60] of notes) {
    setTimeout(() => beep(freq, durationMs), atMs);
  }
}

export const sfx = {
  /** Menü satırı değişti / geri. */
  menu: () => beep(620, 45),
  /** Onay / ekran değişimi. */
  select: () => beep(520, 45),
  /** Yem yenildi. */
  eat: () => beep(880, 70, 0.06),
  /** Oyun bitti: düşen iki notalı ölüm sesi. */
  die: () => sequence([[200, 0, 180], [120, 190, 320]]),
  /** Oyun başlama jingle'ı. */
  start: () => sequence([[440, 0], [560, 70], [680, 140, 90]]),
};
